import { __decorate } from "tslib";
import { id_netscapeCertExtension } from "./object_identifiers";
import { AsnType, AsnTypeTypes, AsnPropTypes, AsnProp } from "@peculiar/asn1-schema";
export const id_netscapeBaseUrl = `${id_netscapeCertExtension}.2`;
let NetscapeBaseUrl = class NetscapeBaseUrl {
    constructor(value) {
        this.value = "";
        if (value) {
            this.value = value;
        }
    }
};
__decorate([
    AsnProp({ type: AsnPropTypes.IA5String })
], NetscapeBaseUrl.prototype, "value", void 0);
NetscapeBaseUrl = __decorate([
    AsnType({ type: AsnTypeTypes.Choice })
], NetscapeBaseUrl);
export { NetscapeBaseUrl };
